export const data = [
  {
    name: "Syvaznoy",
    description: "Development of the online store system",
    type: "iOS / Android / WebLk",
    lang: "Swift / Kotlin / PHP",
    desc1: "Co-development with Svyaznoy.",
    desc2: "Our project team consists of 6 experts:",
    experts: ["Mobile-developers;", "Backend-developer;", "Analyst."],
    desc3:
      "Also project team include analysts, product owner, PM and business customer on the client side.",
  },

  {
    name: "My Perekrestok",
    description: "Release, support and development of «My Perekrestok 2.0»",
    type: "iOS / Android / WebLk",
    lang: "Swift / Kotlin / Python / Angular / React / Go",
    desc1: "This app is a tool of a loyalty program.​",
    desc2: "Our project team consists of 26 experts:",
    experts: [
      "Backend-developers;",
      "JS-developers;",
      "Mobile-developers;",
      "Analyst;",
      "QA-engineers;",
      "Managers;",
      "DevOps (SLA 24/7);",
      "Second line of support.",
    ],
    desc3:
      "Also project team include analysts, product owner, PM and business customer on the client side.",
  },

  {
    name: "Sunlight",
    description: "Development mobile app",
    type: "iOS / Android",
    lang: "Swift / Kotlin / Java / Objective-C",
    desc1: "Co-development with Sunlight.​",
    desc2: "Our project team consists of 4 experts:",
    experts: [
      "Mobile-developers.",
    ],
    desc3:
      "",
  },

  {
    name: "ZdravCity",
    description: "Development of the site and integration with the customer's internal ERP system Development mobile app",
    type: "iOS / Android / WebLk",
    lang: "PHP / Bitrix / JavaScript / Objective-C / Kotlin / Java",
    desc1: "",
    desc2: "Our project team consists of 17 experts:",
    experts: [
      "PHP-developers;",
      "JS-developers;",
      "Mobile-developers;",
      "QA-Engineers;",
      "Manager.",
    ],
    desc3:
      "Also project team include analysts, product owner, PM and business customer on the client side.",
  },

  {
    name: "Amigo",
    description: "Development of a sales management system from the manufacturer for dealers",
    type: "WebLk",
    lang: "PHP / Laravel / JavaScript / VueJS",
    desc1: "Development of an administrative panel for a blinds and curtains manufacturer, a widget and a personal account for dealers.",
    desc2: "Our project team consists of 2 experts:",
    experts: [
      "Backend-developer;",
      "Frontend-developer.",
    ],
    desc3:
      "Also project team include analysts and PM on the client side.",
  },

  {
    name: "Flacon Magazine",
    description: "Redesign of the site based on the customer's layouts, implementation of the personal account, integration with analytics systems",
    type: "WebLk",
    lang: "PHP / Bitrix / Yii2 / Vue.js / Nuxt.js",
    desc1: "",
    desc2: "Our project team consists of 4 experts:",
    experts: [
      "PHP-developers;",
      "JS-developers.",
    ],
    desc3:
      "Also project team include product owner, PM, business customer on the client side.",
  },
];
